import type { ComponentConfig } from "@puckeditor/core"
import { SectionBase, sectionStyle } from "../lib/section"

export type QuoteProps = SectionBase & {
  quote: string
  author: string
  align: "left" | "center"
}

export const Quote: ComponentConfig<QuoteProps> = {
  fields: {
    quote: { type: "textarea", contentEditable: true },
    author: { type: "text", label: "Author (optional)", contentEditable: true },
    align: {
      type: "radio",
      options: [
        { value: "left", label: "Left" },
        { value: "center", label: "Center" },
      ],
    },
    background: {
      type: "radio",
      options: [
        { value: "none", label: "Transparent" },
        { value: "muted", label: "Muted" },
        { value: "accent", label: "Dark" },
      ],
    },
    paddingY: {
      type: "radio",
      options: [
        { value: "none", label: "None" },
        { value: "sm", label: "Small" },
        { value: "md", label: "Medium" },
        { value: "lg", label: "Large" },
      ],
    },
  },

  defaultProps: {
    quote: "The best coffee is the one you brew with intention.",
    author: "",
    align: "left",
    background: "none",
    paddingY: "md",
  },

  render: ({ quote, author, align, background, paddingY }) => {
    const s = sectionStyle({ background, paddingY })
    const dark = background === "accent"

    return (
      <section style={s}>
        <blockquote
          style={{
            maxWidth: 720,
            margin: "0 auto",
            padding: "0 24px",
            textAlign: align,
            borderLeft: align === "left" ? "3px solid var(--site-accent, #7c3aed)" : "none",
            paddingLeft: align === "left" ? 24 : 0,
          }}
        >
          <p
            style={{
              fontSize: "1.375rem",
              lineHeight: 1.6,
              fontStyle: "italic",
              fontWeight: 500,
              color: dark ? "rgba(255,255,255,0.92)" : "#1f2937",
              marginBottom: author ? 12 : 0,
            }}
          >
            {quote}
          </p>
          {author && (
            <footer style={{ fontSize: "0.9375rem", color: dark ? "rgba(255,255,255,0.6)" : "#6b7280" }}>
              — {author}
            </footer>
          )}
        </blockquote>
      </section>
    )
  },
}
